import { useEffect } from 'react';
import { WelcomeScreen } from '@/components/home/WelcomeScreen.js';
import { ChatTabBar } from '@/components/chat/ChatTabBar.js';
import { useServices } from '@/contexts/ServicesContext.js';
import { useChatTabsStore } from '@/stores/chatTabsStore.js';

export function WelcomePage() {
  const { sessionService } = useServices();
  const tabs = useChatTabsStore((state) => state.tabs);
  const setActiveTab = useChatTabsStore((state) => state.setActiveTab);

  // Ensure we're in welcome state when this page mounts
  // We only run this on mount ([]) because running it on isWelcomeState change
  // would cause a race condition where the state is reset just as we're trying
  // to navigate away to a new chat session.
  useEffect(() => {
    console.log('[WelcomePage] Mounting, ensuring welcome state');
    sessionService.returnToWelcome();

    // Find and activate the first welcome tab (sessionId === null)
    const welcomeTab = tabs.find((tab) => tab.sessionId === null);
    if (welcomeTab) {
      setActiveTab(welcomeTab.id);
    }
  }, []); // Important: Run only on mount!

  return (
    <main className="flex-1 overflow-hidden flex flex-col">
      <ChatTabBar />
      <div className="flex-1 overflow-hidden">
        <WelcomeScreen />
      </div>
    </main>
  );
}
